module.exports = new __parcel__URL__("battleroyale_title_text.af9892be.png").toString();